module.exports = __webpack_public_path__ + "static/img/barlogo.ec1a535.png";


//////////////////
// WEBPACK FOOTER
// ./static/webp1/barlogo.png
// module id = Um6f
// module chunks = 1